export default {
  aigc_tools_title: "AI应用案例库&工具集",
  aigc_tools_search_placeholder: "搜索一个你感兴趣的应用, 或直接开始聊天",
  aigc_tools_chat: "聊天",
  aigc_tools_tool: "工具",
  aigc_tools_example: "案例",
  aigc_tools_class: "类 型",
  aigc_tools_scene: "场 景",
  aigc_tools_inner_info: "仅展示内部可直接使用内容",
  aigc_tools_resource_upload: "资源上传",
  aigc_tools_app_details: "应用详情",
  aigc_tools_access_details: "访问详情",
  aigc_tools_contact_admin: "联系管理员",
  aigc_tools_similar: "相似推荐",
  aigc_tools_contact: "请联系@benzemazhu",
  aigc_tools_empty: "当前筛选选择下没有数据。",
  aigc_tools_tag_new: "新",
  aigc_tools_tag_internal: "内部可用",
  aigc_tools_delete_message: "是否删除资源？",
  aigc_tools_delete_des: "您确定要删除<b>{name}</b>吗？删除操作是不可撤销的，请确认操作。",
};